import classes from './BackgroundColor.module.scss'
import { cloneElement } from 'react'
import type { ReactElement } from 'react'

export interface Props {
  children: ReactElement
  variant: 'ThemeSlider' | 'ThemeSubBackground' | 'ThemeTableHeaderBackground' | 'ThemeReadOnly'
}

const BackgroundColor = ({
  children,
  variant
}: Props) => {
  const inheritClasses = children.props.className || ''

  const styleClasses = [
    inheritClasses,
    classes.BackgroundColor,
    classes[variant]
  ].filter(styleClass => styleClass).join(' ')

  return (
    cloneElement(
      <div />,
      {
        ...children.props,
        className: styleClasses
      },
      children
    )
  )
}

export default BackgroundColor
